import { createFileRoute, notFound } from "@tanstack/react-router";
import { BlogLayout } from "@/components/BlogLayout";
import { getPostBySlug } from "@/lib/blog-data";
import { buildSeoMeta } from "@/lib/seo";

const SLUG = "facebook-conversions-api-wdrozenie-krok-po-kroku";

export const Route = createFileRoute("/blog/facebook-conversions-api-wdrozenie-krok-po-kroku")({
  head: () => {
    const post = getPostBySlug(SLUG)!;
    return buildSeoMeta({
      title: post.title,
      description: post.metaDescription,
      path: `/blog/${SLUG}`,
      type: "article",
      image: post.ogImage,
      ogTitle: post.ogTitle,
      ogDescription: post.ogDescription,
    });
  },
  component: () => {
    const post = getPostBySlug(SLUG);
    if (!post) throw notFound();
    return <BlogLayout post={post} />;
  },
});
